const APP_DOWNLOAD_MODAL_STORAGE_KEY_PREFIX = 'appDownloadModalState'

type AppDownloadModalStatus = 'completed' | 'dismissed'

export interface AppDownloadModalState {
  dismissedAt?: number
  status: AppDownloadModalStatus
}

const getAppDownloadModalStorageKey = (campaignId: string): string => {
  return `${APP_DOWNLOAD_MODAL_STORAGE_KEY_PREFIX}:${campaignId}`
}

const getStorage = (): Storage | null => {
  if (typeof window === 'undefined') return null

  return window.localStorage || null
}

export const getAppDownloadModalState = (
  campaignId?: string
): AppDownloadModalState | null => {
  if (!campaignId) return null

  try {
    const storage = getStorage()
    const item = storage?.getItem(getAppDownloadModalStorageKey(campaignId))
    if (!item) return null

    const parsedItem = JSON.parse(item)
    if (
      parsedItem?.status !== 'completed' &&
      parsedItem?.status !== 'dismissed'
    ) {
      return null
    }

    return parsedItem
  } catch {
    return null
  }
}

export const markAppDownloadModalCompleted = (campaignId?: string) => {
  if (!campaignId) return

  try {
    getStorage()?.setItem(
      getAppDownloadModalStorageKey(campaignId),
      JSON.stringify({ status: 'completed' })
    )
  } catch {
    return
  }
}

export const markAppDownloadModalDismissed = (
  campaignId?: string,
  dismissedAt = Date.now()
) => {
  if (!campaignId) return

  try {
    getStorage()?.setItem(
      getAppDownloadModalStorageKey(campaignId),
      JSON.stringify({ dismissedAt, status: 'dismissed' })
    )
  } catch {
    return
  }
}

export const canShowAppDownloadModal = ({
  campaignId,
  now = Date.now(),
  reopenAfterMinutes
}: {
  campaignId?: string
  now?: number
  reopenAfterMinutes: number
}): boolean => {
  const state = getAppDownloadModalState(campaignId)
  if (!state) return true
  if (state.status === 'completed') return false
  if (typeof state.dismissedAt !== 'number') return true

  return now - state.dismissedAt >= reopenAfterMinutes * 60 * 1000
}
